import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function LiderstvoPEM() {
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Liderstvo" />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">Liderstvo</h2>
              <p>
                <strong>Studijski program:</strong> Poslovna ekonomija
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Liderstvo
              </p>
              <p>
                <strong>Nastavnik:</strong>
              </p>
              <p>
                <strong>Status predmeta:</strong> Obavezan
              </p>
              <p>
                <strong>Broj ECTS:</strong> 7
              </p>
              <p>
                <strong>Uslov:</strong> nema
              </p>
              <h3>Cilj predmeta</h3>
              <p>
                Cilj predmeta je upoznavanje studenata sa fundamentalnim
                pojmovima i svim aspektima liderstva, sličnostima i razlikama
                između menadžera i lidera, kao i sa organizacionim
                specifičnostima vezanim za pojavu liderstva u organizacijama.
                Kroz predavanja i praktične vježbe student se edukuje o
                uticajima i moći lidera, liderske taktike uticaja, liderstva u
                timskom radu, kao i pristupima zasnovanim na osobinama lidera,
                ponašanju lidera, moći i uticaju lidera. Poseban aspekt obuhvata
                sukobe i konflikte, uloge i uticaje lidera u organizaciji. Cilj
                je i obrada motivacije u liderstvu kao faktora uspjeha i razvoja
                organizacije.
              </p>
              <h3>Ishod predmeta</h3>
              <p>
                Predmet osposobljava studente da usvoje liderske vještine, da
                ovladaju tehnikama upravljanja i rješavanja problema, kao i da
                prepoznaju izvore moći i činioce koji utiču na ostvarivanje
                liderstva. Obradjene su sve dimenzije liderstva u organizacijama
                i njihov uticaj u procesima odlučivanja i motivacije u
                organizaciji. Takođe, budući svršeni studenti biće edukovani za
                potpunu i samostalnu ulogu lidera - vođe.
              </p>
              <h3>Sadržaj predmeta</h3>
              <p>
                Definicija liderstva, sagledavanje naučno istraživačkih pravaca
                u proučavanju liderstva, Fiedlerov kontigentski model i teorija
                supstitucije za liderstvo su štivo za prvi dio programa
                predmeta. Nakon toga student se kroz praktičnu i teorijsku
                nastavu edukuje o savladavanju otpora prema organizacionim
                promjenama, organizacionoj kulturi i interpretativnim šemama.
                Nakon dva kolokvijuma student se edukuje o snagama kulture i
                subkulture u organizaciji, kao i o ulozi lidera u procesu
                kreiranja kulture u organizaciji. Uloga lidera u rješanju sukoba
                i konflikata i motivaciji saradnika – sledbenika lidera.
              </p>

              <h3>Metode izvođenja nastave</h3>
              <p>
                Nastava je u skladu sa zahtjevima predmeta interaktivna. Težište
                je na razvijanju receptivne i automatizaciji reproduktivne
                sposobnosti uz pomoć različitih tipova vježbi i simulacije
                tipičnih poslovnih situacija, pojave i rješavanja konflikata i
                različitih metoda vođenja. Predavanja su auditorna uz podršku
                savremenih učila i aktivno učešće studenata kroz obradu
                određenih tema i rješavanje određenih situacija u organizaciji.
                Rad na vežbama obuhvata: prezentaciju i utvrđivanje gradiva
                obrađenog na nastavi, provjeru znanja i različitih primjera kao
                i izlaganje seminarskih radova.
              </p>

              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>2P + 2V</td>
                    <td>
                      Definicije i sadržaj liderstva. Pregled naučno
                      istraživačkih pravaca u proučavanju liderstva.
                    </td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>2P + 2V</td>
                    <td>
                      Teorijski pristupi zasnovani na osobinama lidera, na
                      ponašanju lidera, na moći i uticaju lidera, situacioni
                      pristupi.
                    </td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>2P + 2V</td>
                    <td>
                      Fiedler-ov kontigencijski model. “Put-cilj” kontigencijska
                      teorija.
                    </td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>2P + 2V</td>
                    <td>
                      Teorija supstitucije za liderstvo. Integrativni pristup
                      proučavanju liderstva.
                    </td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>2P + 2V</td>
                    <td>Uloga lidera u pokretanju i vođenju promjena</td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td>Kolokvijum I</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>2P + 2V</td>
                    <td>
                      Moć i uticaj lidera. Izvori moći. Liderske taktike uticaja
                    </td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>2P + 2V</td>
                    <td>Savladavanje otpora prema organizacionim promjenama</td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>2P + 2V</td>
                    <td>Liderstvo i timski rad.</td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>2P + 2V</td>
                    <td>
                      Izvori i vrste moći lidera. Organizaciona kultura kao
                      faktor uspješnog liderstva
                    </td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>2P + 2V</td>
                    <td>Interpretativne šeme.</td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td>Kolokvijum II</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>2P + 2V</td>
                    <td>
                      Osobine i svojstva uspješnih lidera. Liderska vizija i
                      odnos sa sledbenicima. Motivacija saradnika za
                      realizovanje liderske vizije.
                    </td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>2P + 2V</td>
                    <td>
                      Uloga lidera u procesu kreiranja kulture u organizaciji.
                    </td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>2P + 2V</td>
                    <td>
                      Sprovođenje organizacionih promjena i uloga lidera u tom
                      procesu.
                    </td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td>Sveobuhvatni ispit</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td>Ovjera semestra i upis ocjena</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td>Popravni ispitni rok</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 4 č / 3 h</td>
                            <td>Ukupno: 45 č</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 2 č / 1 h 30min</td>
                            <td>Nastava + završni ispit: 54 č</td>
                          </tr>
                          <tr>
                            <td>Vježbe: 2 č / 1h 30min</td>
                            <td>Priprema i ovjera semestra: 10 č</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 15 h</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default LiderstvoPEM;
